import { Grid } from '@mui/material';
import React from 'react';

const AppLayout = ({ children, ...rest }) => {
  return (
    <Grid container {...rest}>
      {children}
    </Grid>
  );
};

export default AppLayout;
